import Vue from "./../init";

const uri = Vue.http.options.root + "/auth/";

class Auth {
  login(credentials) {
    return Vue.http.post(
      uri + "login",
      credentials,
      (response, status, request) => {
        return response;
      }
    );
  }

  logout() {
    return Vue.http.post(
      uri + "logout",
      {
        q: Date.now()
      },
      (response, status, request) => {
        return response;
      }
    );
  }

  twoFactor(token) {
    return Vue.http.post(
      uri + "two-factor",
      {
        token: token
      },
      (response, status, request) => {
        return response;
      }
    );
  }

  logoutRedirect() {
    location.href = uri + "logout";
  }

  init(data) {
    return Vue.http.post(uri, data, (response, status, request) => {
      return response;
    });
  }

  loginThirdParty(provider) {
    location.href = uri + provider;
  }

  redirect() {
    location.href = uri + "redirect";
  }

  redirectBeforeLogin(obj) {
    if (!obj.redirect_uri) {
      obj.redirect_uri = obj.redirect_url;
    }

    let query = Object.keys(obj)
      .filter(key => obj[key] !== "" && obj[key] !== null)
      .map(key => key + "=" + obj[key])
      .join("&");

    const queryString = query.length > 0 ? "?" + query : "";

    location.href = uri + queryString;
  }
}

export default new Auth();
